export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9229.525e65a6.jpg";